module.exports = __webpack_public_path__ + "images/category_lp/pc/media3_8964559ccfc0c66fe38a61ae148b9027.jpg";